import { useEffect, useState } from 'react'

/** El valor recién después de `ms` sin cambios (para no consultar por cada tecla). */
export function useDebounced<T>(value: T, ms: number): T {
  const [v, setV] = useState(value)
  useEffect(() => {
    const t = setTimeout(() => setV(value), ms)
    return () => clearTimeout(t)
  }, [value, ms])
  return v
}
